import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { API_BASE_URL } from "../../config/config";

const AdvantagesSection = () => {
  const { t, i18n } = useTranslation();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const languageMap = {
    tj: 1,
    ru: 2,
    en: 3,
  };

  const getLanguageCode = (lang) => languageMap[lang] || 2;

  useEffect(() => {
    const langCode = getLanguageCode(i18n.language);
    setLoading(true);
    setError(null);

    axios
      .get(`${API_BASE_URL}/api/faqs?lang=${langCode}&page=1`, {
        headers: {
          accept: "text/plain",
          "api-version": "1.0",
        },
      })
      .then((response) => {
        const data = response.data;
        if (data && data.enttities && Array.isArray(data.enttities)) {
          setItems(data.enttities);
        } else {
          setItems([]);
        }
      })
      .catch((err) => {
        console.error("Error fetching FAQs:", err);
        setError(t("NoAvailable"));
      })
      .finally(() => setLoading(false));
  }, [i18n.language]);

  const CustomIcon = ({ iconUrl }) => (
    <div
      style={{
        color: "rgb(12, 63, 40)",
        fontSize: "28px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "100%",
      }}
    >
      {iconUrl ? (
        <img
          src={iconUrl}
          alt="FAQ Icon"
          style={{
            width: "28px",
            height: "28px",
            filter:
              "brightness(0) saturate(100%) invert(13%) sepia(44%) saturate(1234%) hue-rotate(122deg) brightness(94%) contrast(88%)",
          }}
        />
      ) : (
        <span>?</span>
      )}
    </div>
  );

  if (loading) {
    return (
      <div className="container py-5">
        <div className="text-center">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container py-5">
        <div className="text-center">
          <p className="text-danger">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div
      className="container py-5"
      data-aos="fade-right"
      style={{ position: "relative" }}
    >
      <div className="text-center mb-5">
        <h1
          className="display-5 fw-bold mb-3"
          style={{ color: "rgb(12, 63, 40)" }}
        >
          {t("advantagesSection.title")}
        </h1>
        <p className="lead">{t("advantagesSection.subtitle")}</p>
      </div>
      <div className="row row-cols-1 row-cols-md-2 g-4">
        {Array.isArray(items) && items.length > 0 ? (
          items.map((item) => (
            <div key={item.id} className="col">
              <div className="d-flex align-items-start">
                <div
                  className="bg-light rounded-circle p-3 me-3 d-flex align-items-center justify-content-center"
                  style={{ width: "70px", height: "70px" }}
                >
                  <CustomIcon iconUrl={item.faqsIcon} />
                </div>
                <div>
                  <h3
                    className="h5 fw-bold"
                    style={{ color: "rgb(12, 63, 40)" }}
                  >
                    {item.question}
                  </h3>
                  <p className="text-muted">{item.answer}</p>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="col-12 text-center">
            <p className="text-muted">{t("NoAvailable")}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdvantagesSection;
